export default __webpack_public_path__ + "static/media/mission_control.58d4d82e.png";